import { pageRoutes } from 'shared/routes';
import { REDIRECT_URI } from 'entities/profile';
import { dateToString, getDefaultEndDate, getDefaultStartDate } from 'shared/lib/format';

export const setRedirectUri = () => {
  const redirect = `${window.location.pathname}${window.location.search}`;
  const basePath = redirect.startsWith(pageRoutes.internal.auth) ? pageRoutes.internal.auth : pageRoutes.app.auth;

  const param = redirect !== '/' ? `?${REDIRECT_URI}=${encodeURIComponent(redirect)}` : '';

  return `${basePath}${param}`;
};

type FilterKeys = `filters[${string}]`;

export const getDefaultDateNavigation = ({ fromKey, toKey }: { fromKey: FilterKeys; toKey: FilterKeys }) => {
  const queryParams = `${fromKey}=${dateToString(getDefaultStartDate())}&${toKey}=${dateToString(getDefaultEndDate())}`;

  return `?${new URLSearchParams(queryParams).toString()}`;
};
